var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"page-header"},[_c('i',{staticClass:"fab fa-delicious"}),_vm._v(" Összesítőpult "),_c('small')]),_c('h2',[_vm._v("üdv")])])
}]

export { render, staticRenderFns }